import { useState, useEffect, useRef} from 'react';
import './classes/CertificatePage.css';
import { configData } from "../config";
import Loading from './Loading';


const CertificatePage = ({uid,userDetails}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [certificates, setCertificates] = useState([]);
    // useEffect(() => {
       
    //     setTimeout(() => {
    //       setIsLoading(false);
    //     }, 800);
        
    //  },[]);
   
      useEffect(() => {
const certificateData = [
  {
    id: 1,
    link: "/certificate/gayatest-gayathritest/658273/course/SPORTS/3833",
    image: "https://www.smwwearena.com/certificates/image/14347_37467-1.png",
    title: "TestNewcourse Newcourse Course",
    date: "Jul 14, 2025"
  },
  {
    id: 2,
    link: "/certificate/gayatest-gayathritest/658273/course/BBAS/3647",
    image: "https://www.smwwearena.com/certificates/image/14347_37168-1.png",
    title: "Basketball Apprenticeship",
    date: "Nov 18, 2024"
  },{
    id: 3,
    link: "/certificate/gayatest-gayathritest/658273/course/DVS/3655",
    image: "https://www.smwwearena.com/certificates/image/14347_37530-1.png",
    title: "Basketball Video Performance Analysis w/ Synergy Course",
    date: "Apr 28, 2025"
  },{
    id: 4,
    link: "/certificate/gayatest-gayathritest/658273/course/DVE/3525",
    image: "https://www.smwwearena.com/certificates/image/14347_37529-1.png",
    title: "Football Video Performance Analysis w/ Catapult Course",
    date: "Jun 02, 2025"
  },{
    id: 5,
    link: "/certificate/gayatest-gayathritest/658273/course/DVEH/3720",
    image: "https://www.smwwearena.com/certificates/image/14347_38011-1.png",
    title: "Hockey Video Performance Analysis w/ Catapult Course",
    date: "Mar 31, 2025"
  },{
    id: 6,
    link: "/certificate/gayatest-gayathritest/658273/course/BBPD/3643",
    image: "https://www.smwwearena.com/certificates/image/14347_38011-1.png",
    title: "Basketball Player Development Course",
    date: "May 26, 2025"
  },{
    id: 7,
    link: "/certificate/gayatest-gayathritest/658273/course/BAM/3772",
    image: "https://www.smwwearena.com/certificates/image/14347_38146-1.png",
    title: "Baseball Agent Course",
    date: "Jun 16, 2025"
  },{
    id: 8,
    link: "/certificate/gayatest-gayathritest/658273/course/DSA/3816",
    image: "https://www.smwwearena.com/certificates/image/14347_38253-1.png",
    title: "Sports Analytics and AI Course",
    date: "May 05, 2025"
  },
];
setCertificates(certificateData);
  }, []);
     
     return ( 
        <>
  
     <div className="certificate-container-main">
{/* {<Loading />} */}
      <div class="user-wrapper">
			<img class="user_img" src="/images/new_logo.png"/>
			{/* <h1 class="user-name">{userDetails.first_name} {userDetails.last_name}'s Certificates</h1>*/}
		</div>
    <hr/>
    <div style={{"display": "flex","flexWrap": "wrap"}}>    
               <div className="certificates-list">
      {certificates.map((item) => (
        <div key={item.id} className="certificate-content-wrapper">
          <a href={item.link}>
            <div className="certificate-img-wrapper">
              <img className="certificate-img" src={item.image} />
            </div>

            <div className="certificate-content">
              <h3 style={{"borderLeft":0,"marginTop":"-10px"}}>{item.title}</h3>
              <span className="certificate-date">{item.date}</span>
            </div>
          </a>
        </div>
      ))}
    </div>
            </div>
    </div>
     
     </>
     );
};

export default CertificatePage;